const algoliasearch = require("algoliasearch")

// search jobs
const getSearchResults = async jobsListData => {
  const { search, filtersArr, pageNo } = jobsListData
  try {
    const indexName = process.env.GATSBY_ALGOLIA_SECONDARY_JOB_INDEX_NAME
    const term = search || ""
    const client = algoliasearch(
      process.env.GATSBY_ALGOLIA_APP_ID,
      process.env.GATSBY_ALGOLIA_SEARCH_KEY
    )
    const index = client.initIndex(indexName)
    var locfilters
    var addLocFilters
    if (
      filtersArr?.selectedLocations?.length == 0 &&
      filtersArr?.locationid !== "" &&
      filtersArr?.locationid !== undefined
    ) {
      locfilters = `Job_Posting_Location_Data.Primary_Location_Reference: ${filtersArr?.locationid}`
      addLocFilters = `Job_Posting_Location_Data.Additional_Location_Reference:${filtersArr?.locationid}`
    }
    if (filtersArr?.selectedLocations.length > 0) {
      locfilters = filtersArr?.selectedLocations?.map(
        itm => `Job_Posting_Location_Data.Primary_Location_Reference: ${itm}`
      )
      addLocFilters = filtersArr?.selectedLocations?.map(
        itm => `Job_Posting_Location_Data.Additional_Location_Reference: ${itm}`
      )
    }
    let locationFilters = addLocFilters ? [...locfilters, ...addLocFilters] : locfilters
    
    if (filtersArr?.jobFamily) {
      const arr = filtersArr?.jobFamily?.split("|")
      var familyFilter = arr?.map(id => `Job_Family_Reference:${id}`)
    }
    if (filtersArr?.jobType) {
      var jobtypeFilter = `Job_Type_Reference:${filtersArr?.jobType}`
    }
    if (filtersArr?.timeType) {
      var timeTypeFilter = `Time_Type_Reference:${filtersArr?.timeType}`
    }
    if (filtersArr?.earlyCareers == 1) {
      var careerFilter = `Job_Requisition_Detail_Data.Job_Application_Template_Reference:Early_Career_Application_Template`
    }

    const Filters = [
      locationFilters,
      familyFilter,
      jobtypeFilter,
      timeTypeFilter,
      careerFilter,
    ]
    const facetFilters = Filters.filter(e => e !== undefined)
    const options = {
      ...(facetFilters.length && { facetFilters: facetFilters }),
      page: pageNo,
      hitsPerPage: 20,
    }
    const result = await index.search(term, {
      ...options,
    })
    return result
  } catch (error) {
    console.log(error, "algo")
    return { error: error.message }
  }
}

const getSearchResultsNews = async data => {
  const { pageType = "", filters, pageNo, search = "" } = data

  if (typeof window != "undefined"){ 
  try {
    /* setup algolia connection */
    
    const urlSearch = window.location.search
    const fetchURL = new URLSearchParams(document.location.search)
    
    let filterString = {}
    for (let pair of fetchURL.entries()) {
      filterString[pair[0]] = pair[1]
    }
    
    const getQueryFunc = (tags)=>{
      let queryString = new URLSearchParams(document.location.search)
      let featuredData = queryString.getAll(tags).filter(el => el!=="").map(el=>el.replace(/[/]/g,"")).shift()
      return featuredData
    }
    const filterValue = filterString.filter
    
    const fop = getQueryFunc("fop")
    const ftag = getQueryFunc("ftag")
    const indexName = (!urlSearch) || (!filterValue) ? process.env.GATSBY_ALGOLIA_INDEX_CONTENTFUL_NEWS_PAGES :  process.env.GATSBY_ALGOLIA_INDEX_CONTENTFUL_PAGES
    
    // init Algolia client
    const client = algoliasearch(
      process.env.GATSBY_ALGOLIA_APP_ID,
      process.env.GATSBY_ALGOLIA_SEARCH_KEY
    )
    // target the index
    const index = client.initIndex(indexName)

    let facetFilters

// Handle the inclusive AND (fop=i) with ftag
    if (fop === 'i' && ftag) {
      facetFilters = [
        filterValue.split('|').map(
          item => `content.imageTextWarpper.categoryLinks.label:${item}`
        ), `content.imageTextWarpper.categoryLinks.label:${ftag}`
      ];
    }
    // Handle the inclusive AND (fop=i)
    else if (fop === 'i') {
      facetFilters = filterValue.split('|').map(
        item => `content.imageTextWarpper.categoryLinks.label:${item}`
      )
    }
    else if(ftag){
      facetFilters = [filterValue?.split('|').map(
            item => `content.imageTextWarpper.categoryLinks.label:${item}`
          )]
    }
    else{
      facetFilters = [
            filters.map(
              item => `content.imageTextWarpper.categoryLinks.label:${item}`
            )
          ]
    }
   

    const options = {
      ...(facetFilters.length && { facetFilters: facetFilters }),
      page: pageNo,
      hitsPerPage: 10,
    }
 
    const searchTerm = search || ""

    const result = await index.search(searchTerm, {
      ...options,
    })

    return result
  } catch (error) {
    return { error: error.message }
  }
}
}
// global search
const getGlobalSearchResults = async data => {
  const { search = "", pageNo = 1 } = data
  try {
    /* setup algolia connection */
    const indexName = process.env.GATSBY_ALGOLIA_GLOBAL_SEARCH_INDEX

    // init Algolia client
    const client = algoliasearch(
      process.env.GATSBY_ALGOLIA_APP_ID,
      process.env.GATSBY_ALGOLIA_SEARCH_KEY
    )
    // target the index
    const index = client.initIndex(indexName)

    /* ~~~~~~~~~~ ooo ~~~~~~~~~~ */

    const options = {
      page: pageNo - 1,
      hitsPerPage: 10,
    }
    const searchTerm = search || ""

    const result = await index.search(searchTerm, {
      ...options,
    })
    return result
  } catch (error) {
    return { error: error.message }
  }
}
module.exports = {
  getSearchResults,
  getSearchResultsNews,
  getGlobalSearchResults,
}